import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import BadgeOutlined from "@mui/icons-material/BadgeOutlined";

export const PermitsEmptyState: React.FC = () => (
  <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <Stack spacing={1} alignItems="center">
      <BadgeOutlined sx={{ fontSize: 64 }} color="action" />
      <Typography variant="h6" fontWeight={600}>
        No permits issued yet
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400, textAlign: "center" }}>
        Once CurbPass is active for your jurisdiction, issued permits will appear here — with real-time status,
        per-vehicle tracking, and one-click export.
      </Typography>
    </Stack>
  </Box>
);

export default PermitsEmptyState;
